module.exports = __webpack_public_path__ + "img/applyvacation_bg.576a21d8.png";